/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2019 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Display.Bounds
 */

module.exports = {

    CenterOn: require('./CenterOn'),
    GetBottom: require('./GetBottom'),
    GetCenterX: require('./GetCenterX'),
    GetCenterY: require('./GetCenterY'),
    GetLeft: require('./GetLeft'),
    GetOffsetX: require('./GetOffsetX'),
    GetOffsetY: require('./GetOffsetY'),
    GetRight: require('./GetRight'),
    GetTop: require('./GetTop'),
    SetBottom: require('./SetBottom'),
    SetCenterX: require('./SetCenterX'),
    SetCenterY: require('./SetCenterY'),
    SetLeft: require('./SetLeft'),
    SetRight: require('./SetRight'),
    SetTop: require('./SetTop')
    
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/phaser/src/display/bounds/index.js
// module id = 1125
// module chunks = 0